import React, { Component } from 'react';
import { getAuthInfo, getAccInfo } from './service'
import { Toast, Form, Button, Dialog, Space, SpinLoading, Card, Modal } from 'antd-mobile'
import { debounce } from '../../utils/util'
import './index.scss';

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
        };
    }(),
}

class AuthenticateMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            projectId: null,
            authInformation: [],
            userInformation: [],
            userId: null,
            telPhone: null,
            loginCode: null,
            accountId: null,
            isLoading: true,
            showModal: false,
            phoneSystem: null,
        }
        this.onSubmit = debounce(this.onSubmit, 1000)

    }
    componentDidMount() {
        document.title = "认证信息"
        let search = window.location.search.slice(1)
        let params = search.split('&')
        var theRequest = new Object()
        for (let i = 0; i < params.length; i++) {
            theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
        }
        let paramsInfo = {}
        try {
            if (theRequest?.params) {
                paramsInfo = JSON.parse(theRequest.params)
            } else if (theRequest?.accountInfo) {
                paramsInfo = JSON.parse(theRequest.accountInfo)
            }
        } catch (e) {
            console.error('authenticateMessage params parse failed', e)
        }
        this.setState({
            projectId: paramsInfo.projectId || theRequest.projectId,
            userId: paramsInfo.userId || theRequest.userId,
            loginCode: paramsInfo.loginCode || paramsInfo.token || theRequest.loginCode || theRequest.token,
            accountId: paramsInfo.accountId || theRequest.accountId,
            phoneSystem: paramsInfo.phoneSystem || theRequest.phoneSystem,
        }, () => {
            this.getAccInfo()
        })
    }
    getAuthInfo = () => {
        let { userId, projectId, telPhone, loginCode, accountId } = this.state
        let params = {
            // projectId: 8,
            // userId: 372471850,
            // loginCode: 'c9d5637760ac4e030e20a98ffc4501c4',
            // accountId: 100000447,
            projectId: this.state.projectId,
            userId: this.state.userId,
            loginCode: this.state.loginCode,
            accountId: this.state.accountId,
        }
        if (this.state.phoneSystem) {
            params.phoneSystem = this.state.phoneSystem;
        }
        getAuthInfo(params).then(res => {
            if (res.errorCode == 0) {
                const { projectId, userId, loginCode, accountId, phoneSystem } = this.state
                if (!projectId || !userId || !loginCode || !accountId) {
                    Toast.show({
                        content: '缺少认证参数，请从小程序重新进入',
                        position: 'bottom',
                    })
                    return
                }
                const url_cas = JSON.parse(res.data.json).verifyUrl
                const encryptedParams = encodeURIComponent(JSON.stringify({
                    projectId,
                    accountId,
                    userId,
                    loginCode,
                    phoneSystem,
                    urlCas: url_cas,
                }));
                this.props.history.push(`/authenticateBinding?accountInfo=${encryptedParams}`);
                this.setState({
                    authInformation: res.data,
                    isLoading: false
                })
            } else {
                Toast.show({
                    content: res.errorMessage,
                    position: 'bottom',
                })
                this.setState({
                    isLoading: false
                })
            }
        })
    }
    getAccInfo = () => {
        let { userId, projectId, telPhone, loginCode, accountId } = this.state
        let params = {
            // projectId: 8,
            // userId: 372471850,
            // loginCode: 'c9d5637760ac4e030e20a98ffc4501c4',
            // accountId: 100000447,
            projectId: this.state.projectId,
            userId: this.state.userId,
            loginCode: this.state.loginCode,
            accountId: this.state.accountId,
            // phoneSystem:'H5',
            version:'1.0.0'
        }
        if (this.state.phoneSystem) {
            params.phoneSystem = this.state.phoneSystem;
        }
        getAccInfo(params).then(res => {
            if (res.errorCode == 0) {
                let oneCardAuthInfo = res.data?.oneCardAuthInfo != null ? JSON.parse(res.data?.oneCardAuthInfo) : []
                this.setState({
                    userInformation: oneCardAuthInfo,
                    isLoading: false
                })
            } else {
                Toast.show({
                    content: res.errorMessage,
                    position: 'bottom',
                })
                this.setState({
                    isLoading: false
                })
            }
        })
    }

    // 返回app
    onBackApp = () => {
        var userAgent = navigator.userAgent;
        const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
        if (browser.versions.android || OpenHarmony) {
            window.android.onCampusPayExit();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.onCampusPayExit.postMessage('');
            return;
        }
    }

    showConfirm = () => {
        this.setState({ showModal: true });
    }

    onCancel = () => {
        this.setState({ showModal: false });
    }

    render() {
        const { authInformation, userInformation } = this.state
        return (
            <>
                {!this.state.isLoading ? <div className="card-auth-msg-page">
                    <Form layout='horizontal'
                        onFinish={this.showConfirm}
                        footer={
                            <Button
                                style={{ background: 'linear-gradient( 270deg, #5BA1FD 0%, #6FBDFF 100%)' }}
                                block
                                color='primary'
                                type='submit'
                                size='large'
                                onClick={() => this.getAuthInfo()}
                            >
                                重新认证
                            </Button>
                        }
                    >
                        <Card>
                            {/* {authInformation.cvvName && <div style={{ fontSize: '13px', marginTop: '12px' }}><span style={{ color: '#999999' }}>{authInformation.cvvName}：</span>{}</div>} */}
                            {Object.entries(userInformation).map(([key, value]) => (
                                <div style={{ fontSize: '13px', margin: '18px 0' }} key={key}>
                                    <span style={{ color: '#999999' }}>{key}：</span>{value}
                                </div>
                            ))}
                        </Card>
                    </Form>
                </div>
                    :
                    <div className="pay-page-loading">
                        <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
                            <SpinLoading color='primary' />
                        </Space>
                    </div>
                }
            </>
        );
    }

}

export default AuthenticateMessage;
